import { isNull } from '@aloft/toolkit-shared';

import { makeRowID } from './makeRowID.ts';

export function scrollToIndex(index: number) {
  const rowElementID = makeRowID(index);
  const element = document.getElementById(rowElementID);
  if (isNull(element)) {
    console.error('Could not find element with ID: ', rowElementID);
    return;
  }
  element.scrollIntoView({ block: 'center', behavior: 'instant' });
}
